let tabs = document.querySelectorAll(".tab-toggle-item");
let tabContents = document.querySelectorAll(".tab-content-block");
tabs.forEach((tab, index) => {
  tab.addEventListener("click", () => {
    tabContents.forEach((content) => {
      content.classList.remove("active");
    });
    tabs.forEach((tab) => {
      tab.classList.remove("active");
    });
    tabContents[index].classList.add("active");
    tabs[index].classList.add("active");
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Select all anchor tags on the page
  var links = document.querySelectorAll('a');

  // Iterate through each link
  links.forEach(function(link) {
      // Check if the link is external
      var isExternal = new RegExp('//' + window.location.host).test(link.href) === false;
      // If the link is external, set target attribute to "_blank"
      if (isExternal) {
          link.setAttribute('target', '_blank');
      }
  });
});

// Function to execute when #insta-feed is added to the DOM
function onInstaFeedAdded() {
    var instaFeedH2 = document.querySelector('#insta-feed h2');
    if (instaFeedH2) {
        var link = document.createElement('a');
        link.href = 'https://www.instagram.com/mandasenofficial/';
        link.textContent = '@mandasenofficial';
        link.setAttribute('target', '_blank');
        instaFeedH2.insertAdjacentElement('afterend', link);
    } else {
        console.error('The #insta-feed h2 element was not found.');
    }
}

// Create an observer instance to monitor DOM changes
function checkForInstaFeed() {
    var instaFeedH2 = document.querySelector('#insta-feed h2');

    // If the element exists, proceed to add the link
    if (instaFeedH2) {
        var link = document.createElement('a');
        link.href = 'https://www.instagram.com/mandasenofficial/';
        link.textContent = '@mandasenofficial';
        link.setAttribute('target', '_blank');
        instaFeedH2.insertAdjacentElement('afterend', link);
    } else {
        // If not found, wait for a bit and then try again
        setTimeout(checkForInstaFeed, 500); // Check again after 500ms
    }
}

// Start the polling process
checkForInstaFeed();




// document.addEventListener("DOMContentLoaded", function() {
//   window.addEventListener('scroll', makeSticky);

//   var navbar = document.getElementById("navbar");
//   var announcement = document.getElementById("announcement-bar");
//   var body = document.body;
  
//   function makeSticky() {
//     if (window.pageYOffset >= 0) {  // Set to the desired pixel value
//       navbar.classList.add("sticky");
//       announcement.classList.add("sticky");
//       body.style.paddingTop = '95px';
//     } else {
//       navbar.classList.remove("sticky");
//       announcement.classList.remove("sticky");
//       body.style.paddingTop = '0px';
//     }
//   }

// });